import './App.css';
import './styles/rtl-support.css';
import './styles/sidebar-rtl.css';
import * as React from "react";
import Box from "@mui/material/Box";
import {
    createTheme,
    ThemeProvider,
    useMediaQuery
} from "@mui/material";
import {TokenProvider, TokenContext} from "./Context/TokenContext";
import {TranslationContext, TranslationProvider} from "./Context/TranslationContext";
import {Route, BrowserRouter as Router, Routes, Navigate, useLocation} from "react-router-dom";
import {CookiesProvider} from "react-cookie";

import {useContext, useEffect} from "react";

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import {Authentication} from "./Componant/Anthantication/Authentication";
import Init from "./Init";

// Composant pour protéger les routes
function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading, accessToken } = useContext(TokenContext);
    const translationContext = useContext(TranslationContext);
    const translation = translationContext ? translationContext.translation : null;
    const location = useLocation();

    console.log('🛡️ [ProtectedRoute] État:', {
        isAuthenticated,
        isLoading,
        hasAccessToken: !!accessToken,
        accessTokenPreview: accessToken ? accessToken.substring(0, 20) + '...' : 'AUCUN',
        currentPath: location.pathname
    });

    if (isLoading) {
        console.log('⏳ [ProtectedRoute] Chargement en cours...');
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                {translation ? translation('app.loading.authentication', 'App.json') : 'Loading authentication...'}
            </Box>
        );
    }

    if (!isAuthenticated) {
        console.log('🚫 [ProtectedRoute] Utilisateur NON authentifié, redirection vers /authentication/callback');
        console.log('📋 [ProtectedRoute] Détails:', {
            isAuthenticated,
            hasAccessToken: !!accessToken,
            accessTokenLength: accessToken?.length || 0
        });
        // Redirection vers la page d'authentification qui gérera le flux OAuth
        return <Navigate to="/authentication/callback" replace={true} />;
    }

    console.log('✅ [ProtectedRoute] Utilisateur authentifié, accès autorisé');
    return children;
}

// Composant principal de l'app avec gestion des routes
function AppContent() {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const darkTheme = createTheme({
        palette: {
            mode: prefersDarkMode ? 'dark' : 'light',

            background: {
                default: prefersDarkMode ? '#252525' : '#f5f5f5',
            },

            common: {
                white: {
                    dark: '#cecece'
                },
            },

            greyTimeline: {
                main: '#121212',
            },

            appBackground: {
                main: '#f5f5f5',
                light: '#f5f5f5',
                dark: '#252525'
            },

            reactflowButton: {
                main: '#FFFFFF',
                light: '#FFFFFF',
                dark: '#252525'
            },

            sidebar: {
                dark: '#cecece',
                light: '#616161',
                main: '#616161'
            },

            nodeHandle: {
                dark: '#000000FF',
                light: '#FFFFFF',
                main: '#FFFFFF'
            },

            nodeCard: {
                dark: '#252525',
                light: '#FFFFFF',
                main: '#FFFFFF'
            },

            primary: {
                main: '#FF7233',
                light: '#FF7233',
                dark: '#FF7233',
            }
        },
        typography: {
            fontFamily: '"Poppins", sans-serif',
            allVariants: {
                color: prefersDarkMode ? '#cecece' : '#000000FF',
            }
        },
    });

    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{ background: 'appBackground.main', minHeight: "100vh" }}>
                <Routes>
                     Route spéciale pour le callback OAuth - TOUJOURS accessible
                    <Route
                        path="/authentication/callback"
                        element={<Authentication />}
                    />


                    {/* Route d'accueil protégée */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Init />
                             </ProtectedRoute>
                        }
                    />

                    {/* Toutes les autres routes protégées */}
                    <Route
                        path="/*"
                        element={
                            <ProtectedRoute>
                                <Init />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </Box>
        </ThemeProvider>
    );
}

function App() {
    // Gestion globale des erreurs non capturées
    useEffect(() => {
        const handleError = (event) => {
            console.error('Erreur non capturée:', event.error);
        };

        const handleRejection = (event) => {
            console.error('Promise rejetée non gérée:', event.reason);
        };

        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleRejection);

        return () => {
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleRejection);
        };
    }, []);

    return (
        <div className="App">
            <CookiesProvider>
                <TranslationProvider>
                    <Router>
                        <TokenProvider>
                            <AppContent />
                        </TokenProvider>
                    </Router>
                </TranslationProvider>
            </CookiesProvider>
        </div>
    );
}

export default App;